export default function DevBadge({ className = '' }: { className?: string }) {
  if (process.env.REACT_APP_SHOW_DEV_BANNER?.toLowerCase() !== 'true')
    return null;

  return (
    <span
      className={`inline-flex items-center rounded bg-amber-400 px-2 py-1 text-[10px] font-semibold uppercase tracking-wide text-[#111111] ${className}`}
    >
      <span className="md:hidden">Dev</span>
      <span className="hidden md:inline">Development</span>
    </span>
  );
}
